import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-www-main-description-list',
	templateUrl: './www-main-description-list.component.html',
	styleUrls: ['./www-main-description-list.component.scss'],
})
export class WwwMainDescriptionListComponent extends ListComponent {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatSort) sort: MatSort;
	dataSource = new MatTableDataSource<any>();
	@ViewChild(MatPaginator) paginator: MatPaginator;
	displayedColumns: string[] = ['id', `name`, `use`, `description`, `edit`];

	protected apiType = 'bag';
	protected apiUrl = 'offer/description';

	protected convertData(data: any) {
		data.results.forEach((item) => {
			switch (item.use) {
				case 'F':
					item.use = 'Samolot';
					break;
				case 'A':
					item.use = 'Wszystkie';
					break;
				case 'C':
					item.use = 'Autokar';
					break;

				default:
					break;
			}
		});

		this.dataSource = new MatTableDataSource<any>(data.results);
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;

		return this.dataSource;
	}
}
